import { CustomizationIcon } from '../assets';
import { ROUTES } from '../lib';
import { Link } from '../ui/link';

export const DashboardCustomizationBtn = () => {
  return (
    <Link to={ROUTES.CUSTOMIZE} className="!z-50 block h-8 w-8 p-1">
      <CustomizationIcon className="!h-full !w-full" />
    </Link>
  );
};
